module.exports = __webpack_public_path__ + "img/arrow_icon.fd393d87.svg";